const profileConfig = {
	svcHost: '',

	retrieveStaffProfile: {
		url: '/profile',
		method: 'GET',
		timeout: 60000
	}
};

export default profileConfig;
